"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "8", height: "10", viewBox: "0 0 8 10", className: "Icon board-locked", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement(
                "g",
                { fill: "#31303A" },
                _react2.default.createElement("path", { d: "M6.5 5H6V2.893C6 1.853 5.114 1 4 1c-1.11 0-2 .857-2 1.893V5H1V2.893C1 1.295 2.347 0 4 0c1.657 0 3 1.29 3 2.893V5h-.5z" }),
                _react2.default.createElement("path", { d: "M0 4h8v6H0z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/board-locked.js
// module id = 1786
// module chunks = 0